function u(e, n) {
  return e == null ? void 0 : e[n];
}
export {
  u as default
};
